module.exports = __webpack_public_path__ + "img/76.5c989b3b.jpg";